// src/services/DemandeService.js
import { base_url } from "../utils/constante";

const API_URL = base_url;

const entetes = () => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    };
};

/** { verrouille, nb_reservations, demande_en_cours } */
export const getVerrouEvenement = async (id) => {
    const res = await fetch(`${API_URL}createur/evenement/${id}/verrou`, {
        method: "GET",
        headers: entetes(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || "Impossible de vérifier l'événement.");
    return data;
};

/** type : report | annulation | modification */
export const envoyerDemandeEvenement = async (id, { type, message, nouvelle_date }) => {
    const res = await fetch(`${API_URL}createur/evenement/${id}/demande`, {
        method: "POST",
        headers: entetes(),
        body: JSON.stringify({ type, message, nouvelle_date: nouvelle_date || null }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || "Envoi impossible, réessayez.");
    return data;
};